import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

let Gist = null;

const loadGist = async () => {
  try {
    const GistModule = await import('customerio-gist-web');
    Gist = GistModule.Gist || GistModule.default || GistModule;
    window.Gist = Gist;
    console.log('✅ Gist module imported successfully');
    return true;
  } catch (error) {
    console.error('❌ Failed to import Gist module:', error);
    return false;
  }
};

const siteId = process.env.REACT_APP_CUSTOMERIO_SITE_ID;
const apiKey = process.env.REACT_APP_CUSTOMERIO_API_KEY;

const addDismissButtonToGistOverlay = () => {
  try {
    const gistElements = document.querySelectorAll('[class*="gist"], [class*="Gist"], .gist-overlay');

    gistElements.forEach(element => {
      if (element.querySelector('.gist-dismiss-btn')) {
        return;
      }

      const dismissBtn = document.createElement('button');
      dismissBtn.className = 'gist-dismiss-btn';
      dismissBtn.innerHTML = '✕';
      dismissBtn.style.cssText = `
        position: absolute;
        top: 10px;
        right: 10px;
        width: 30px;
        height: 30px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        z-index: 10000;
        transition: background-color 0.2s;
      `;

      dismissBtn.addEventListener('mouseenter', () => {
        dismissBtn.style.background = 'rgba(0, 0, 0, 0.9)';
      });

      dismissBtn.addEventListener('mouseleave', () => {
        dismissBtn.style.background = 'rgba(0, 0, 0, 0.7)';
      });

      dismissBtn.addEventListener('click', () => {
        console.log('🔍 Dismiss button clicked');
        if (window.Gist && typeof window.Gist.dismissMessage === 'function') {
          window.Gist.dismissMessage();
        }
      });

      element.style.position = 'relative';
      element.appendChild(dismissBtn);
      console.log('✅ Dismiss button added to Gist overlay');
    });
  } catch (error) {
    console.error('Failed to add dismiss button:', error);
  }
};

const initializeCustomerIO = async () => {
  try {
    const cioanalytics = AnalyticsBrowser.load({
      writeKey: apiKey,
      disableSettingsFetch: true,
    });
    window.cioanalytics = cioanalytics;

    await loadGist();

    if (Gist && typeof Gist.setup === 'function') {
      try {
        await Gist.setup({
          siteId,
          appearance: {},
        });

        Gist.messageShown(() => {
          console.log('🔍 Customer.io message shown - adding dismiss button...');
          setTimeout(() => {
            addDismissButtonToGistOverlay();
          }, 100);
        });

        Gist.messageDismissed(() => {
          console.log('🔍 Customer.io message dismissed');
        });

        Gist.messageError(error => {
          console.error('❌ Customer.io message error:', error);
        });

        Gist.messageAction(action => {
          console.log('🔍 Customer.io message action:', action);
        });

        console.log('✅ Gist setup completed successfully');
      } catch (error) {
        console.error('❌ Failed to setup Gist:', error);
      }
    } else {
      console.warn('⚠️ Gist not available for initialization');
    }

    console.log('✅ Customer.io initialization completed');
  } catch (error) {
    console.error('❌ Failed to initialize Customer.io:', error);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCustomerIO());
} else {
  initializeCustomerIO();
}
